var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "st-Footer" }, [
    _c("div", { staticClass: "st-Footer_Pagetop", on: { click: _vm.goTop } }, [
      _c("i", { staticClass: "el-icon-arrow-up" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "st-Footer_Inner" }, [
      _c("nav", { staticClass: "st-FtDirectory" }, [
        _c(
          "div",
          { staticClass: "st-FtDirectory_Logo" },
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c("img", {
                staticClass: "logo-img-navbar-coypright",
                attrs: {
                  src: require("../../../static/img/logo/logo-white.png"),
                  alt: ""
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/company/profile" } }, [
                  _vm._v("企業情報")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c(
              "li",
              { staticClass: "mb-md-0" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/solution/logistics-automation" } },
                  [_vm._v("ロボティクス自動化ソリューション\n            ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/solution/low-code" } }, [
                  _vm._v("Lowコードソリューション")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/service/index" } }, [
                  _vm._v("サービス案内")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/recruit/index" } }, [
                  _vm._v("採用情報")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/contact/index" } }, [
                  _vm._v("お問い合わせ")
                ])
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "st-FtPress pt-3" }, [
        _c(
          "div",
          {
            staticClass: "sw-Section_HeaderS mb-0 copyright-news-appear-1",
            attrs: { "data-appear": "true" }
          },
          [
            _c("div", { staticClass: "st-Grid_Inner-copyright_news p-0" }, [
              _c("div", { staticClass: "row col-12" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("h2", { staticClass: "mb-3 pt-4" }, [
                    _c(
                      "span",
                      {
                        staticClass: "sw-Section_Header-en mb-3",
                        staticStyle: { "font-size": "1.7rem" }
                      },
                      [
                        _c(
                          "b",
                          [_c("font", [_c("font", [_vm._v("NEWS")])], 1)],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "sw-Section_Header-ja",
                        staticStyle: { "font-size": "1.3rem" }
                      },
                      [
                        _c(
                          "b",
                          { staticStyle: { height: "20px" } },
                          [_c("font", [_c("font", [_vm._v("お知らせ")])], 1)],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "st-FtPress_Slide swiper-container mt-5 mt-md-5 mb-0"
          },
          [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.newsList, function(item, index) {
                return _c("div", { key: index, staticClass: "swiper-slide" }, [
                  item.title.length > 10
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-border-copyright-silde pb-2 mb-3 text-left",
                          staticStyle: {
                            "min-height": "50px",
                            "font-size": "12px",
                            "padding-top": "5px",
                            width: "170px"
                          }
                        },
                        [
                          _c("div", { staticClass: "pl-3" }, [
                            _vm._v(_vm._s(item.title))
                          ])
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "text-border-copyright-silde pb-2 mb-3 text-center",
                          staticStyle: {
                            "min-height": "50px",
                            "font-size": "12px",
                            "padding-top": "13px"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.title) +
                              "\n            "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goNewsDetail(item.newsId)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "../../../static/img/news/" + item.imgSrc
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "vol mt-3",
                          staticStyle: { "font-size": "12px" }
                        },
                        [_vm._v(_vm._s(item.date))]
                      )
                    ]
                  )
                ])
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtPress_Slide-scrollbar" })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "st-FtLegal pt-5" }, [
      _c("div", { staticClass: "st-FtLegal_Inner" }, [
        _c("div", { staticClass: "st-FtLegal_Right" }, [
          _c("ul", { staticClass: "st-FtLegal_Link" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/policy" } }, [
                  _vm._v("サイトポリシー")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/privacy" } }, [
                  _vm._v("プライバシーポリシー")
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(6)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "st-FtDirectory_Column-title",
        staticStyle: { width: "200px" }
      },
      [_vm._v("COMPANY"), _c("i")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "st-FtDirectory_Column-title",
        staticStyle: { width: "200px" }
      },
      [_vm._v("SOLUTIONS"), _c("i")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "st-FtDirectory_Column-title",
        staticStyle: { width: "200px" }
      },
      [_vm._v("SERVICE"), _c("i")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "st-FtDirectory_Column-title",
        staticStyle: { width: "200px" }
      },
      [_vm._v("RECRUIT"), _c("i")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "st-FtDirectory_Column-title",
        staticStyle: { width: "200px" }
      },
      [_vm._v("CONTACT US"), _c("i")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "60px" } }, [
      _c("p", { staticStyle: { "font-size": "2.2rem" } }, [
        _c("img", {
          attrs: {
            src: require("../../../static/img/home/sm.png"),
            width: "60",
            height: "60"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "st-FtLegal_Copyright pb-5 pb-md-0",
        staticStyle: { "margin-bottom": "0rem" }
      },
      [
        _c("small", [
          _vm._v("© 株式会社ロボティクスソリューションズ All Rights Reserved.")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52511a6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52511a6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/copyright.vue
// module id = null
// module chunks = 